"use strict";
import React, { Component, ReactNode } from "react";
import { Image } from "react-native";

export default (props) => {
  return <Image {...props}></Image>;
};
